export default "__VITE_ASSET__DoMpbQa9__"